// External packages
import * as ReactAria from 'react-aria-components';
import { Controller } from 'react-hook-form';

// Components
import { Label, SubLabel } from 'components/Forms';
import { PlainButton } from 'components/Button';

// Utils
import { twJoin } from 'tailwind-merge';

type FileInputProps = {
  selectedFile?: any;
  onChange?: (file: File | null) => void;
  value?: File | null;
  isInvalid?: boolean;
} & ReactAria.FileTriggerProps;

export const FileInput: React.FC<FileInputProps> = ({
  selectedFile,
  onChange,
  value,
  isInvalid,
  ...props
}) => {
  return (
    <ReactAria.FileTrigger {...props} onSelect={(file) => onChange?.(file![0])}>
      <PlainButton
        className={twJoin(
          'h-14 w-full cursor-pointer text-center rounded-lg border border-dashed border-gray-300 px-4 text-gray-500 transition-colors hover:border-gray-400',
          isInvalid &&
            'border-red-600 text-red-600 placeholder:text-red-600 hover:border-red-800'
        )}
      >
        {value?.name || selectedFile || 'Odaberite datoteku'}
      </PlainButton>
    </ReactAria.FileTrigger>
  );
};

type FileInputFieldProps = {
  name: string;
  label?: string;
  isInvalid?: boolean;
  wrapperClassName?: string;
  className?: string;
  fileTriggerProps?: ReactAria.FileTriggerProps;
};

export const FileInputField: React.FC<FileInputFieldProps> = ({
  name,
  label,
  isInvalid,
  wrapperClassName,
  fileTriggerProps,
  className,
  ...props
}) => {
  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => (
        <div className={wrapperClassName}>
          <Label
            className={twJoin(
              'mb-2 text-sm font-medium text-gray-700',
              isInvalid && 'text-red-500'
            )}
            htmlFor={name}
          >
            {label}
          </Label>
          <FileInput
            {...{ ...props, ...fileTriggerProps }}
            value={field.value}
            onChange={field.onChange}
            selectedFile={field.value?.name}
            isInvalid={fieldState.invalid}
          />
          {fieldState.error && (
            <SubLabel role="alert" slot="errorMessage" colorScheme="error">
              {fieldState.error.message}
            </SubLabel>
          )}
        </div>
      )}
    />
  );
};
